import React from "react"
import styled from "styled-components"
import { Copy } from "../../styles/typography"
import { MainButton } from "../../styles/buttons"
import { StepContainer } from "../../styles/reusables"

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  button {
    min-width: 150px;
  }

  :nth-child(1) {
    margin-right: 5px;
  }
  :nth-child(2) {
    margin-left: 5px;
  }
`

const GetStarted = ({ setStep }) => (
  <StepContainer>
    <Copy>
      Do you already have a <b>Shopify</b> account?
    </Copy>
    <Actions>
      <MainButton onClick={() => setStep(4)} whileHover={{ scale: 1.01 }}>
        Yep
      </MainButton>
      <MainButton onClick={() => setStep(2)} whileHover={{ scale: 1.01 }}>
        Nope
      </MainButton>
    </Actions>
  </StepContainer>
)

export default GetStarted
